// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-tags__container___sUAJL","tag":"styles-tags__tag___3lGt3","selected":"styles-tags__selected___k91Pa","focus":"styles-tags__focus___1Ya4a","blur":"styles-tags__blur___1ffsr","rotate":"styles-tags__rotate___1XAXQ","fadein":"styles-tags__fadein___honQH","slideFromRight":"styles-tags__slideFromRight___2BldU","waves":"styles-tags__waves___2RBaI"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/containers/About/styles-tags.scss
// module id = ./resources/assets/js/containers/About/styles-tags.scss
// module chunks = 0